define('common/ko/extension/lazyList',['knockout'], function (ko) {

    ko.subscribable.fn.context = ko.subscribable.fn.context || ko.observable();

    ko.extenders.lazyList = function(target, settings) {

        var count = ko.observable(ko.unwrap(settings.initialCount || ko.unwrap(settings))),
            delay = ko.unwrap(settings.delay),
            done = false,
            addItem = function() {
                count(count() + 1);
                if (count() < target().length) {
                    window.requestAnimationFrame(addItem);
                } else {
                    done = true;
                }
            };

        // if we are being crawled we dont want to lazy load anything
        if (target.context() && target.context().crawl()) {
            return target;
        }

        var limitedList = ko.pureComputed(function () {
            if (!target()) {
                return [];
            }
            return done ? target() : target().slice(0, count());
        });

        setTimeout(function() {
            window.requestAnimationFrame(addItem);
        }, delay || 16);

        return limitedList;
    };

});

